import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TranslateModule } from '@ngx-translate/core';
import { PipeModule } from 'src/app/pipes/pipes.module';
import { FiltersService } from 'src/app/services/filters.service';
import { DateRangePickerDirective } from '../../directives/date-range-picker.directive';
import { DateRangePickerComponent } from '../date-range-picker/date-range-picker.component';
import { FilterViewHeaderComponent } from '../filter-view-header/filter-view-header.component';
import { GenericPencilFilterComponent } from '../generic-pencil-filter/generic-pencil-filter.component';
import { PencilButtonComponent } from '../pencil-button/pencil-button.component';
import { PencilMultiSelectTagsComponent } from '../pencil-multi-select-tags/pencil-multi-select-tags.component';
import { PencilUserSearchTagsComponent } from '../pencil-user-search-tags/pencil-user-search-tags.component';
import { PencilMultiSelectModalComponent } from '../pencil-multi-select-modal/pencil-multi-select-modal.component';
import { FilterData, FilterType } from './filters.interface';

@UntilDestroy()
@Component({
  selector: 'app-generic-filters-view',
  templateUrl: './generic-filters-view.component.html',
  styleUrls: ['./generic-filters-view.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FilterViewHeaderComponent,
    GenericPencilFilterComponent,
    PencilButtonComponent,
    DateRangePickerComponent,
    PencilUserSearchTagsComponent,
    PencilMultiSelectTagsComponent,
    PencilMultiSelectModalComponent,
    PipeModule,
    TranslateModule,
    FormsModule,
    DateRangePickerComponent,
    DateRangePickerDirective,
  ],
})
export class GenericFilterComponent implements OnInit {
  @ViewChild('dateFilter', { static: true }) dateFilterTemplate?: TemplateRef<any>;
  @ViewChild('checkBoxFilter', { static: true }) checkBoxFilterTemplate?: TemplateRef<any>;
  @ViewChild('userSearch', { static: true }) userSearchTemplate?: TemplateRef<any>;
  @ViewChild('siteSearch', { static: true }) siteSearchTemplate?: TemplateRef<any>;
  @ViewChild('multiSelectFilter', { static: true }) multiSelectTemplate?: TemplateRef<any>;
  @ViewChild('modalFilter', { static: true }) modalFilterTemplate?: TemplateRef<any>;

  @Input() showFilterIcon = true;
  @Input() showCloseButton = true;
  @Input() showLastDivider = true;

  @Output() togglePanel: EventEmitter<void> = new EventEmitter<void>();

  protected todayDate = new Date();

  public filterTypeToTemplateMap: Map<FilterType, TemplateRef<any> | undefined> = new Map();

  constructor(public filtersService: FiltersService) {}

  ngOnInit(): void {
    this.initFilterKeyToTemplateMap();
  }

  initFilterKeyToTemplateMap() {
    this.filterTypeToTemplateMap = new Map([
      [FilterType.Date, this.dateFilterTemplate],
      [FilterType.UserSearch, this.userSearchTemplate],
      [FilterType.SiteSearch, this.siteSearchTemplate],
      [FilterType.Checkbox, this.checkBoxFilterTemplate],
      [FilterType.MultiSelect, this.multiSelectTemplate],
      [FilterType.Role, this.multiSelectTemplate],
      [FilterType.SpaceSearch, this.modalFilterTemplate],
    ]);
  }

  handleFilterApplied(filter: FilterData, filterValue: any) {
    if (filter.isLocked) {
      return;
    }

    const filterHasValuesSelected = filter.handleFilterSelection(filterValue);
    if (filterHasValuesSelected) {
      this.filtersService.updateFilter(filter);
    } else {
      this.filtersService.removeFilter(filter.key);
    }
  }

  handleClearFilter(filter: FilterData) {
    this.filtersService.removeFilter(filter.key);
  }

  clearAllFilters(): void {
    this.filtersService.clearFilters();
  }

  onClosePanel(): void {
    this.togglePanel.emit();
  }
}
